
import { useLocation } from 'react-router';
import React from 'react';

export function useQuery(queryString = '') {
  const { search } = useLocation();
  const searchString =  queryString.size > 0 ? queryString : search;
  return React.useMemo(() => new URLSearchParams(searchString), [ searchString ]);
}
